module.exports = __webpack_public_path__ + "img/drag-n-drop21.8a602b89.svg";